import { render, staticRenderFns } from "./UserListAdd1.vue?vue&type=template&id=00416920&scoped=true&"
import script from "./UserListAdd1.vue?vue&type=script&lang=js&"
export * from "./UserListAdd1.vue?vue&type=script&lang=js&"
import style0 from "./UserListAdd1.vue?vue&type=style&index=0&id=00416920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00416920",
  null
  
)

export default component.exports